import styled from 'styled-components';
import { Typography } from 'antd';

const { Text } = Typography;

export const ContainerAction = styled.div`
  .action-lock-unlock {
    padding: 12px;
    width: 100%;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .action-lock-unlock-radio {
      padding: 24px 32px;

      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;

      .anticon {
        font-size: 1.1rem;
        margin: 4px 8px;
      }

      .anticon-lock {
        color: red;
      }
      .anticon-unlock {
        color: green;
      }
    }
  }
`;

export const ContainerInfo = styled.div`
  .ant-typography {
    font-size: 0.8rem;
    opacity: 0.8;
  }
`;

export const CancellationValue = styled(Text)`
  padding: 16px 24px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  margin: 16px 0;

  .ant-typography {
    font-size: 1.1rem;
  }
`;

export const ContainerReplacement = styled.div`
  background: #f4f4f4;
  padding: 16px 24px;
  border-radius: 8px;
  border: 1px solid #efefef;
`;

export const ReplacementChoice = styled.div`
  text-align: center;
  margin-top: 16px;
  opacity: 0.8;

  .ant-radio-group {
    width: 100%;
  }
`;
